// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__6nQk4","loginContainer":"styles_loginContainer__ZtuXJ","title":"styles_title__jXhRF","img":"styles_img__F3+OI","btn":"styles_btn__nJmt3"};